import React from 'react';
import {ReactComponent as IconoCerrarSesion} from '../images/log-out.svg';
import {auth} from './../firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
	const navigate = useNavigate();

	const cerrarSesion = async() => {
		try {
			await signOut(auth);
			navigate('/login');
		} catch(error){
		}
	}

	return (
        <span onClick={cerrarSesion}>
            <IconoCerrarSesion />
        </span>
	);
}
 
export default Logout;